module.exports = __webpack_public_path__ + "static/media/logo-light-left-menubar.ab6c1257.png";